export const services = [
  {
    id: 'strategy-growth',
    no: '01',
    title: 'Strategy & Growth',
    text: 'We help leadership teams decide where to focus, which opportunities deserve investment and what to stop doing, so the strategy becomes a set of clear choices the organization can act on.',
    capabilities: ['Corporate Strategy', 'Growth Priorities', 'Market Positioning'],
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_svc01.webp',
  },
  {
    id: 'transformation',
    no: '02',
    title: 'Transformation',
    text: 'We redesign how roles, structures and decisions fit together, then stay close to execution so that change moves from slides into the daily rhythm of the business.',
    capabilities: ['Operating Model', 'Organizational Design', 'Change Execution'],
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_svc02.webp',
  },
  {
    id: 'leadership-change',
    no: '03',
    title: 'Leadership & Change',
    text: 'We work with executive teams on the conversations that shape direction, clarifying who decides what and building the shared commitment that change needs to hold over time.',
    capabilities: ['Leadership Alignment', 'Decision Governance', 'Organizational Effectiveness'],
    img: 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_svc03.webp',
  },
];

export const expertiseHeroImg = 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_auren-exphero.webp';

export const contactHeroImg = 'https://public.readdy.ai/ai/img_res/sandbox/ec5ef1d3c4675c57d9407dc9f601fa86/e42fb93a-155e-4a10-986e-6d55b764f5c6_auren-contact.webp';

export const interestOptions = ['Strategy & Growth', 'Transformation', 'Leadership & Change'];